import {ToggleButton} from '@github-ui/pacer/ToggleButton'
import {TasklistIcon} from '@primer/octicons-react'
import {Button, Tooltip} from '@primer/react'
import {useCallback} from 'react'

import {useChatStateValues} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'

export function PlanningIntentToggle() {
  const manager = useChatManager()
  const {usePlanningIntent, selectedThreadID} = useChatStateValues('usePlanningIntent', 'selectedThreadID')
  const onClick = useCallback(() => manager.setUsePlanningIntent(!usePlanningIntent), [manager, usePlanningIntent])

  if (selectedThreadID) {
    return (
      <Tooltip text="Planning mode is enabled and cannot be toggled after the conversation has started.">
        <Button leadingVisual={TasklistIcon} inactive aria-disabled aria-pressed>
          Plan
        </Button>
      </Tooltip>
    )
  }

  return (
    <ToggleButton icon={<TasklistIcon />} isSelected={usePlanningIntent} onClick={onClick}>
      Plan
    </ToggleButton>
  )
}

try{ PlanningIntentToggle.displayName ||= 'PlanningIntentToggle' } catch {}